export default __webpack_public_path__ + "static/media/no_fav_vendors.9bc72a75.svg";